import ButtonDropdown from "@rio-cloud/rio-uikit/ButtonDropdown"
import { MenuItemProps } from "@rio-cloud/rio-uikit/MenuItem"
import { tenantSelector } from "@/configuration/login/login.selector"
import { useAppSelector } from "@/redux/store"
import { ReactElement, useState } from "react"
import { FormattedMessage } from "react-intl"
import { ConfirmationUploadDialog } from "./ConfirmationUploadDialog"
import type { ConfirmationUploadType } from "./confirmationUploadCsv"

const CONFIRMATION_UPLOAD_TENANT = "rio-eu.test"

export const ConfirmationUploadButtonDropdown = (): ReactElement | null => {
    const tenant = useAppSelector(tenantSelector)
    const [selectedUploadType, setSelectedUploadType] = useState<ConfirmationUploadType>("MATERIAL")
    const [showDialog, setShowDialog] = useState(false)

    if (tenant !== CONFIRMATION_UPLOAD_TENANT) {
        return null
    }

    const openDialog = (uploadType: ConfirmationUploadType): void => {
        setSelectedUploadType(uploadType)
        setShowDialog(true)
    }

    const closeDialog = (): void => {
        setShowDialog(false)
    }

    const uploadItems: MenuItemProps[] = [
        {
            value: <FormattedMessage id="transportOrder.confirmationUpload.menu.materials"/>,
            onSelect: () => openDialog("MATERIAL"),
        },
        {
            value: <FormattedMessage id="transportOrder.confirmationUpload.menu.empties"/>,
            onSelect: () => openDialog("EMPTIES"),
        },
    ]

    return <>
        <ButtonDropdown
            title={<>
                <span className="rioglyph rioglyph-upload margin-right-5"/>
                <FormattedMessage id="transportOrder.confirmationUpload.title"/>
            </>}
            items={uploadItems}
        />

        <ConfirmationUploadDialog
            uploadType={selectedUploadType}
            show={showDialog}
            onClose={closeDialog}
        />
    </>
}
